import { getLinearBalance, getMarketReferenceCurrencyAndUsdBalance, getCompoundedBalance, } from '../../pool-math';
export function generateUserReserveSummary({ userReserve, marketReferencePriceInUsdNormalized, marketReferenceCurrencyDecimals, currentTimestamp, }) {
    const poolReserve = userReserve.reserve;
    const { priceInMarketReferenceCurrency, decimals } = poolReserve;
    const underlyingBalance = getLinearBalance({
        balance: userReserve.scaledYTokenBalance,
        index: poolReserve.liquidityIndex,
        rate: poolReserve.liquidityRate,
        lastUpdateTimestamp: poolReserve.lastUpdateTimestamp,
        currentTimestamp,
    });
    const { marketReferenceCurrencyBalance: underlyingBalanceMarketReferenceCurrency, usdBalance: underlyingBalanceUSD, } = getMarketReferenceCurrencyAndUsdBalance({
        balance: underlyingBalance,
        priceInMarketReferenceCurrency,
        marketReferenceCurrencyDecimals,
        decimals,
        marketReferencePriceInUsdNormalized,
    });
    const variableBorrows = getCompoundedBalance({
        principalBalance: userReserve.scaledVariableDebt,
        reserveIndex: poolReserve.variableBorrowIndex,
        reserveRate: poolReserve.variableBorrowRate,
        lastUpdateTimestamp: poolReserve.lastUpdateTimestamp,
        currentTimestamp,
    });
    const { marketReferenceCurrencyBalance: variableBorrowsMarketReferenceCurrency, usdBalance: variableBorrowsUSD, } = getMarketReferenceCurrencyAndUsdBalance({
        balance: variableBorrows,
        priceInMarketReferenceCurrency,
        marketReferenceCurrencyDecimals,
        decimals,
        marketReferencePriceInUsdNormalized,
    });
    return {
        userReserve,
        underlyingBalance,
        underlyingBalanceMarketReferenceCurrency,
        underlyingBalanceUSD,
        variableBorrows,
        variableBorrowsMarketReferenceCurrency,
        variableBorrowsUSD,
        totalBorrows: variableBorrows,
        totalBorrowsMarketReferenceCurrency: variableBorrowsMarketReferenceCurrency,
        totalBorrowsUSD: variableBorrowsUSD,
    };
}
//# sourceMappingURL=generate-user-reserve-summary.js.map